import { render } from "./ModuleTemplateIndex.vue?vue&type=template&id=75f22c01&scoped=true"
import script from "./ModuleTemplateIndex.vue?vue&type=script&lang=js"
export * from "./ModuleTemplateIndex.vue?vue&type=script&lang=js"

import "./ModuleTemplateIndex.vue?vue&type=style&index=0&id=75f22c01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f22c01"]])

export default __exports__